export const letterSpacings = {
  tightest: '-0.03em',
  tighter: '-0.02em',
  tight: '-0.01em',
  normal: '0',
  wide: '0.01em',
  wider: '0.02em',
  widest: '0.03em',
};

export const lineHeights = {
  normal: 'normal',
  '4xl': '2.75rem',
  '3xl': '2.5rem',
  '2xl': '2rem',
  xl: '1.5rem',
  lg: '1.25rem',
  md: '1.125rem',
  sm: '1rem',
  xs: '0.875rem',
  none: 1,
  base: 1.5,
};

export const fontSizes = {
  xs: '0.625rem',
  sm: '0.75rem',
  md: '0.875rem',
  lg: '1rem',
  xl: '1.125rem',
  '2xl': '1.5rem',
  '3xl': '1.75rem',
  '4xl': '2rem',
  '5xl': '3rem',
  '6xl': '4rem',
};
